import React from 'react';
//import styled from 'styled-components';
//import tw from 'tailwind.macro';

export default function Logo() {
  return (
    <>
      <svg viewBox="0 0 296.25 297.63" xmlns="http://www.w3.org/2000/svg" className="w-32 h32">
        <clipPath id="a">
          <path d="m0 0h296.25v297.63h-296.25z" />
        </clipPath>
        <g clip-path="url(#a)">
          <g fill="#fff" fillRule="evenodd">
            <path d="m139.46 48.43v-9.95h16.47z" />
            <path d="m139.24 63.7.74-11.88 16.9-10.2.25 11.43z" />
            <path d="m138.99 78.97.25-11.39 17.43-10.68.21 11.18z" />
          </g>
          <g clip-path="url(#a)">
            <g fill="#fff">
              <path
                d="m147.21 160.2c-12.37-15.76-35.62-7.79-52.62-8.22l-20.6.25c-.46-1 0-1.73-.21-2.9 23 2.9 50.68-10.19 71.49 4.81a5.91 5.91 0 0 1 1.7 2.43c8.71-11.86 26.66-8.71 39.5-8.5 11.43 1.26 22.79 2.43 34.43 2.19.52 1 0 2 .24 3.14l-10.9.24c-20.59.22-44.86-9.66-62.07 4.84a3.09 3.09 0 0 1 -.74 1.45z"
                fillRule="evenodd"
              />
              <path
                d="m147 168.92c-1.69-4.1-5.33-6.32-9.89-8-20.87-5.08-42 1.69-63.09.22-.95-.47 0-2.19-.46-3.36 23.25 3.14 50.19-10.41 71.53 4.83a6.87 6.87 0 0 1 1.63 2.44l1-.22c1.72-3.91 6.09-5.88 10.44-7.54 20.84-3.88 41.44 2.65 62.56 1.48 1 .46 0 1.9.46 3.11-3.35.24-6.52.52-10.16.52-20.63.46-47.75-11.15-63.77 6.06z"
                fillRule="evenodd"
              />
              <path
                d="m143.61 265.66c-18.94-.49-41.47-11.17-52.87-25.18-18.69-20.64-18.2-50-17.21-74.21 23 3.11 50.93-10.44 71.74 5.08.74.21.53 1.66 1.7 2.18 8.47-11.88 26.17-8.71 38.76-8.25 11.92.74 23.31 2.65 34.71 1.94.7 20.6 2.43 44.13-11.18 64.48-10.44 17.7-31.5 30.58-54 33.47l-7.27.28c7.49-4.38 12.81-15.52 14.78-25l.74-51.43-.51-20.35c-4.84-.74-11.15 2.43-14.53 6.07-.47.24-.74 1.2-1.21 1.9l-.73-.18c-1.67-3.66-5-5.36-9.4-7.3-2 0-4.15-1.23-6.34-1l-.79 52.64c-1.2 13.79 0 33.47 12.87 43.66 0 .25.74.46 1.48 1z"
                fillRule="evenodd"
              />
              <path
                d="m237.68 85c-1.72-2.89-3.63-5.54-7.08-5.82-4.1-1.45-8.72 1.45-10.9 3.91l-58.2-.74c.53-4.86 4.16-7.51 8-9.23a17.5 17.5 0 0 0 11.42 7.51c6.07.74 13.33.74 18.41-3.14 4.38-4.13 5.3-11.4 4.1-16.72-2.65-7.55-4.8-16.26.28-22.82l-17.71.78-15 .74c-7 1.91-10.9 7.51-12.1 14.32a17.19 17.19 0 0 0 9 17.92c-3.66 3.63-8.28 5.82-10.71 10.16l-.52-9.87-17.67 10.39c-3.17-4.62-6.06-7.79-10.9-10.19v-1c3.85-1.91 6.28-4.1 8-7.52 2.43-5.82 1.91-11.36-.74-17-9.7-14.29-29.13-6.32-42.68-9.46 9 10.69-3.91 22.79.46 33.94 1.24 3.66 3.18 6.31 6.56 7.54 7 2.19 14.57 2.65 21.83-1.23l5.58-4.59c3.17 2.4 7 4.59 7 8.93l-58.69-.46a8 8 0 0 0 -2.63-2.35c-3.63-1.66-7.73-1.66-10.68.53a9.57 9.57 0 0 0 -3.64 8.47c0 3.41 2.44 6.06 5.11 7.51a12.06 12.06 0 0 0 10.41-1l-.21 49.24 56.71-1.2c6.32.71 13.86 3.35 16.72 9.17l.47-.46c19.64-19.15 50.43-1.69 73.46-6.53v-8l.74-41.48c1 .5 1.2 1 1.94 1.23a10.85 10.85 0 0 0 10.23-.52c3.35-2.4 4.55-7 3.63-10.9m-164.89 2.94c0 1.69-1.2 2.89-2.89 3.63-1 .49-2.19 0-3.39.25-1.72-.47-2.71-1.45-3.69-3.42-.22-1.67.27-4.13 2-5.3a5.55 5.55 0 0 1 5.82-.28c1.72.74 2.64 3.18 2.18 5.12m91.61 3.14-.93 47.26c-5.36 1.73-12.87 3.17-16 9.24h-.22c-2.86-5.08-9.42-8.25-15.73-8.72l-.28-48-51.85-.22c-1-.77 0-2.43-.49-3.88l120.24.47h17.24c1.17.74.46 2.64.71 4.15zm67.4.74c-.93 1.2-3.11 1.2-4.84 1.2-1.2-.22-1.69-1.2-2.89-1.94a6.57 6.57 0 0 1 .46-6.32c1.45-1 3.64-2.4 5.82-1.2 1.73.47 2.19 1.91 3.17 3.64a4.4 4.4 0 0 1 -1.72 4.62"
                fillRule="evenodd"
              />
              <path d="m.64 131.59 1.17-8.34.71.1-1.07 7.59 6.57.92.92-6.53.71.1-.92 6.53 6.57.92-.1.75z" />
            </g>
            <path
              d="m.64 131.59 1.17-8.34.71.1-1.07 7.59 6.57.92.92-6.53.71.1-.92 6.53 6.57.92-.1.75z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m3.94 113.43.55-2.15 15.35-.78-.18.73-4.72.22-1.71 6.8 4 2.43-.19.73zm8.65 4.42 1.61-6.35-9.15.5-.29 1.14z"
              fill="#fff"
            />
            <path
              d="m3.94 113.43.55-2.15 15.35-.78-.18.73-4.72.22-1.71 6.8 4 2.43-.19.73zm8.65 4.42 1.61-6.35-9.15.5-.29 1.14z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m16.75 98.54-.99 2.57 6.44 2.49-.27.7-13.72-5.3.28-.7 6.6 2.55.98-2.53-4.94-6.86.32-.84 5.15 7.19 8.69-2.21-.35.9z"
              fill="#fff"
            />
            <path
              d="m16.75 98.54-.99 2.57 6.44 2.49-.27.7-13.72-5.3.28-.7 6.6 2.55.98-2.53-4.94-6.86.32-.84 5.15 7.19 8.69-2.21-.35.9z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m29.79 85.38c1.21-2.33 1.21-4.14-1.17-5.38l-9.32-5 .36-.67 9.32 5c2.77 1.5 2.93 3.64 1.44 6.41-1.4 2.59-3.25 3.64-6.05 2.14l-9.32-5 .36-.66 9.32 5c2.33 1.26 3.89.35 5.06-1.81"
              fill="#fff"
            />
            <path
              d="m29.79 85.38c1.21-2.33 1.21-4.14-1.17-5.38l-9.32-5 .36-.67 9.32 5c2.77 1.5 2.93 3.64 1.44 6.41-1.4 2.59-3.25 3.64-6.05 2.14l-9.32-5 .36-.66 9.32 5c2.33 1.23 3.89.32 5.06-1.84z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path d="m36.72 74.79-12.04-8.44.43-.62 11.46 8.03 4.11-5.87.58.42z" fill="#fff" />
            <path
              d="m36.72 74.79-12.04-8.44.43-.62 11.46 8.03 4.11-5.87.58.42z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m30.6 58.04 6.71-8.07.55.46-3.1 3.73 10.75 8.94-.49.58-10.75-8.94-3.13 3.76z"
              fill="#fff"
            />
            <path
              d="m30.6 58.04 6.71-8.07.55.46-3.1 3.73 10.75 8.94-.49.58-10.75-8.94-3.13 3.76z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m42.53 44.48 6.2-5.95.49.52-5.65 5.42 4.23 4.41 4.75-4.55.49.51-4.74 4.56 4.46 4.65 5.65-5.43.5.52-6.2 5.95z"
              fill="#fff"
            />
            <path
              d="m42.53 44.48 6.2-5.95.49.52-5.65 5.42 4.23 4.41 4.75-4.55.49.51-4.74 4.56 4.46 4.65 5.65-5.43.5.52-6.2 5.95z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m53.81 34.14 8.34-6.38.43.57-3.85 2.94 8.5 11.11-.6.46-8.5-11.11-3.88 2.98z"
              fill="#fff"
            />
            <path
              d="m53.81 34.14 8.34-6.38.43.57-3.85 2.94 8.5 11.11-.6.46-8.5-11.11-3.88 2.98z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m70 22.68 1.9-1.16 11.51 10.2-.65.39-3.55-3.11-6 3.65 1.18 4.56-.64.4zm3 9.21 5.6-3.41-6.81-6.08-1 .61z"
              fill="#fff"
            />
            <path
              d="m70 22.68 1.9-1.16 11.51 10.2-.65.39-3.55-3.11-6 3.65 1.18 4.56-.64.4zm3 9.21 5.6-3.41-6.81-6.08-1 .61z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m88.32 12.93 8.77-3.53.55 1.37-3.55 14.43.17.43 8.05-3.23.27.66-8.77 3.53-.54-1.35 3.55-14.42-.19-.46-8.04 3.23z"
              fill="#fff"
            />
            <path
              d="m88.32 12.93 8.77-3.53.55 1.37-3.55 14.43.17.43 8.05-3.23.27.66-8.77 3.53-.54-1.35 3.55-14.42-.19-.46-8.04 3.23z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m108.33 5.87 2.15-.58 8.18 13-.73.19-2.49-4-6.78 1.82-.14 4.7-.73.2zm.37 9.71 6.33-1.7-4.87-7.76-1.14.3z"
              fill="#fff"
            />
            <path
              d="m108.33 5.87 2.15-.58 8.18 13-.73.19-2.49-4-6.78 1.82-.14 4.7-.73.2zm.37 9.71 6.33-1.7-4.87-7.76-1.14.3z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m139.14.67-2.71 15.02-2.43.23-5.48-14.24.75-.07 5.21 13.55 1.34-.13 2.57-14.29z"
              fill="#fff"
            />
            <path
              d="m139.14.67-2.71 15.02-2.43.23-5.48-14.24.75-.07 5.21 13.55 1.34-.13 2.57-14.29z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m149.8.51h2.23l4.23 14.78h-.75l-1.28-4.54-7-.14-1.45 4.49h-.78zm-2.34 9.43 6.55.12-2.52-8.81h-1.18z"
              fill="#fff"
            />
            <path
              d="m149.8.51h2.23l4.23 14.78h-.75l-1.28-4.54-7-.14-1.45 4.49h-.78zm-2.34 9.43 6.55.12-2.52-8.81h-1.18z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m164.42 10-.87 6-.75-.11 2.1-14.54 5.21.75c2.89.41 4.15 1.87 3.73 4.77-.33 2.25-1.41 3.73-3.63 3.83l2.4 6.6-.85-.12-2.37-6.49zm5.58-7.16-4.47-.64-1 7.11 4.47.69c2.64.38 3.75-1 4.06-3.15.35-2.41-.61-3.61-3-4"
              fill="#fff"
            />
            <path
              d="m164.42 10-.87 6-.75-.11 2.1-14.54 5.21.75c2.89.41 4.15 1.87 3.73 4.77-.33 2.25-1.41 3.73-3.63 3.83l2.4 6.6-.85-.12-2.37-6.49zm5.58-7.16-4.47-.64-1 7.11 4.47.69c2.64.38 3.75-1 4.06-3.15.34-2.46-.62-3.66-3.06-4.01z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m183.93 4.8 1.72.49 2.88 15.36.55.16 3.84-13.45.72.21-4.03 14.13-1.72-.49-2.9-15.37-.53-.15-3.84 13.45-.72-.21z"
              fill="#fff"
            />
            <path
              d="m183.93 4.8 1.72.49 2.88 15.36.55.16 3.84-13.45.72.21-4.03 14.13-1.72-.49-2.9-15.37-.53-.15-3.84 13.45-.72-.21z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m200.08 17.73c1.95-4.38 4.13-6.49 8.23-4.66s4 4.82 2.05 9.23c-2.06 4.64-4.05 6.37-8.17 4.54s-4.09-4.66-2.11-9.11m9.55 4.27c1.77-4 2-6.64-1.61-8.25s-5.43.32-7.21 4.33-2 6.49 1.67 8.14 5.28 0 7.15-4.22"
              fill="#fff"
            />
            <path
              d="m200.08 17.73c1.95-4.38 4.13-6.49 8.23-4.66s4 4.82 2.05 9.23c-2.06 4.64-4.05 6.37-8.17 4.54s-4.09-4.66-2.11-9.11zm9.55 4.27c1.77-4 2-6.64-1.61-8.25s-5.43.32-7.21 4.33-2 6.49 1.67 8.14 5.28-.03 7.15-4.22z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m227.92 24.77s-2.27-1.8-3.31-2.43c-2.05-1.24-3.64-1.22-4.72.58-1.33 2.19-.38 3.13 1.66 4.87s3.11 3.13 1.74 5.4c-1.7 2.8-3.62 3-6.1 1.46-1.35-.82-3.67-2.62-3.67-2.62l.46-.58s2.29 1.8 3.56 2.58c2.05 1.24 3.67 1 5-1.2 1.14-1.83.46-2.83-1.54-4.5-2.23-1.87-3.42-3.15-1.82-5.79 1.41-2.32 3.41-2.26 5.8-.81a42 42 0 0 1 3.4 2.46z"
              fill="#fff"
            />
            <path
              d="m227.92 24.77s-2.27-1.8-3.31-2.43c-2.05-1.24-3.64-1.22-4.72.58-1.33 2.19-.38 3.13 1.66 4.87s3.11 3.13 1.74 5.4c-1.7 2.8-3.62 3-6.1 1.46-1.35-.82-3.67-2.62-3.67-2.62l.46-.58s2.29 1.8 3.56 2.58c2.05 1.24 3.67 1 5-1.2 1.14-1.83.46-2.83-1.54-4.5-2.23-1.87-3.42-3.15-1.82-5.79 1.41-2.32 3.41-2.26 5.8-.81a42 42 0 0 1 3.4 2.46z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m234.3 28.05 8.31 6.41-.43.57-3.84-2.96-8.54 11.07-.6-.46 8.54-11.08-3.88-2.98z"
              fill="#fff"
            />
            <path
              d="m234.3 28.05 8.31 6.41-.43.57-3.84-2.96-8.54 11.07-.6-.46 8.54-11.08-3.88-2.98z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m248.72 39.8 1.27 1.26-4.86 14.87.4.4 9.84-9.95.54.53-10.34 10.46-1.27-1.26 4.85-14.88-.39-.39-9.84 9.95-.54-.53z"
              fill="#fff"
            />
            <path
              d="m248.72 39.8 1.27 1.26-4.86 14.87.4.4 9.84-9.95.54.53-10.34 10.46-1.27-1.26 4.85-14.88-.39-.39-9.84 9.95-.54-.53z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m262.44 54.36 5.3 6.76-.56.44-4.83-6.16-4.81 3.77 4.05 5.17-.56.44-4.06-5.17-5.07 3.98 4.83 6.16-.56.44-5.3-6.76z"
              fill="#fff"
            />
            <path
              d="m262.44 54.36 5.3 6.76-.56.44-4.83-6.16-4.81 3.77 4.05 5.17-.56.44-4.06-5.17-5.07 3.98 4.83 6.16-.56.44-5.3-6.76z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m280.71 82.26-14.87 3.46-1.17-2.13 10.91-10.68.36.66-10.38 10.15.64 1.18 14.15-3.3z"
              fill="#fff"
            />
            <path
              d="m280.71 82.26-14.87 3.46-1.17-2.13 10.91-10.68.36.66-10.38 10.15.64 1.18 14.15-3.3z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m284.15 89.7 3.22 7.96-.67.27-2.93-7.26-5.67 2.29 2.47 6.09-.67.27-2.46-6.1-5.98 2.42 2.94 7.27-.66.26-3.22-7.96z"
              fill="#fff"
            />
            <path
              d="m284.15 89.7 3.22 7.96-.67.27-2.93-7.26-5.67 2.29 2.47 6.09-.67.27-2.46-6.1-5.98 2.42 2.94 7.27-.66.26-3.22-7.96z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m276 110 14.22-3.74 1.39 5.28c.94 3.58-2.12 5.64-5.7 6.58s-7.58.74-8.52-2.84zm14.92 1.73-1.2-4.55-12.83 3.37 1.19 4.55c.8 3.05 4.58 3.05 7.63 2.25s6-2.58 5.21-5.62"
              fill="#fff"
            />
            <path
              d="m276 110 14.22-3.74 1.39 5.28c.94 3.58-2.12 5.64-5.7 6.58s-7.58.74-8.52-2.84zm14.92 1.73-1.2-4.55-12.83 3.37 1.19 4.55c.8 3.05 4.58 3.05 7.63 2.25s6.03-2.55 5.23-5.59z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m294.58 125.51 1.11 8.52-.7.09-1.02-7.77-6.07.8.86 6.52-.71.09-.85-6.52-6.4.84 1.02 7.77-.71.09-1.11-8.52z"
              fill="#fff"
            />
            <path
              d="m294.58 125.51 1.11 8.52-.7.09-1.02-7.77-6.07.8.86 6.52-.71.09-.85-6.52-6.4.84 1.02 7.77-.71.09-1.11-8.52z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m294.19 174.46-1.65 8.26-.7-.14 1.5-7.52-6.51-1.29-1.29 6.46-.7-.14 1.29-6.46-6.51-1.3.14-.74z"
              fill="#fff"
            />
            <path
              d="m294.19 174.46-1.65 8.26-.7-.14 1.5-7.52-6.51-1.29-1.29 6.46-.7-.14 1.29-6.46-6.51-1.3.14-.74z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m291.2 187.73-.6 2.14-15.38.4.21-.73 4.72-.1 1.88-6.76-4-2.53.2-.73zm-8.54-4.63-1.76 6.31 9.16-.24.31-1.13z"
              fill="#fff"
            />
            <path
              d="m291.2 187.73-.6 2.14-15.38.4.21-.73 4.72-.1 1.88-6.76-4-2.53.2-.73zm-8.54-4.63-1.76 6.31 9.16-.24.31-1.13z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m272 199.67a21 21 0 0 1 .95-3.79c1.5-4.06 4.45-3.94 8.82-2.32s6.87 3.33 5.33 7.53a21.29 21.29 0 0 1 -1.72 3.51l-.67-.32a21.56 21.56 0 0 0 1.72-3.44c1.36-3.7-1-5.09-4.93-6.53s-6.54-1.81-7.88 1.81a20.93 20.93 0 0 0 -.93 3.73z"
              fill="#fff"
            />
            <path
              d="m272 199.67a21 21 0 0 1 .95-3.79c1.5-4.06 4.45-3.94 8.82-2.32s6.87 3.33 5.33 7.53a21.29 21.29 0 0 1 -1.72 3.51l-.67-.32a21.56 21.56 0 0 0 1.72-3.44c1.36-3.7-1-5.09-4.93-6.53s-6.54-1.81-7.88 1.81a20.93 20.93 0 0 0 -.93 3.73z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m269.49 205.83c-1.13 2.4-.95 4.2 1.46 5.34l9.57 4.51-.32.68-9.57-4.51c-2.85-1.34-3.13-3.47-1.79-6.32 1.26-2.66 3.05-3.81 5.92-2.46l9.58 4.52-.32.68-9.58-4.51c-2.39-1.13-3.9-.15-4.95 2.07"
              fill="#fff"
            />
            <path
              d="m269.49 205.83c-1.13 2.4-.95 4.2 1.46 5.34l9.57 4.51-.32.68-9.57-4.51c-2.85-1.34-3.13-3.47-1.79-6.32 1.26-2.66 3.05-3.81 5.92-2.46l9.58 4.52-.32.68-9.58-4.51c-2.39-1.13-3.9-.15-4.95 2.07z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path d="m265.49 212.66 12.74 7.33-.38.65-12.12-6.97-3.57 6.21-.62-.36z" fill="#fff" />
            <path
              d="m265.49 212.66 12.74 7.33-.38.65-12.12-6.97-3.57 6.21-.62-.36z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m275.04 225.63-5.75 8.78-.6-.39 2.66-4.06-11.7-7.66.42-.63 11.69 7.66 2.68-4.09z"
              fill="#fff"
            />
            <path
              d="m275.04 225.63-5.75 8.78-.6-.39 2.66-4.06-11.7-7.66.42-.63 11.69 7.66 2.68-4.09z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m253.72 230.59.46-.6 5.01 3.86 9.55 1.32-.54.7-8.58-1.21 3.36 8-.54.7-3.72-8.91z"
              fill="#fff"
            />
            <path
              d="m253.72 230.59.46-.6 5.01 3.86 9.55 1.32-.54.7-8.58-1.21 3.36 8-.54.7-3.72-8.91z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m252.67 243.36c3.43 3.35 4.65 6.13 1.5 9.34s-5.92 2.09-9.37-1.29c-3.64-3.56-4.57-6-1.41-9.26s5.8-2.2 9.28 1.21m-7.31 7.48c3.1 3 5.54 4.19 8.3 1.36s1.59-5.2-1.54-8.27-5.38-4.17-8.22-1.28-1.85 5 1.46 8.19"
              fill="#fff"
            />
            <path
              d="m252.67 243.36c3.43 3.35 4.65 6.13 1.5 9.34s-5.92 2.09-9.37-1.29c-3.64-3.56-4.57-6-1.41-9.26s5.8-2.15 9.28 1.21zm-7.31 7.48c3.1 3 5.54 4.19 8.3 1.36s1.59-5.2-1.54-8.27-5.38-4.17-8.22-1.28-1.85 4.96 1.46 8.19z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m247.36 259.03-6.38 5.49-.47-.54 5.81-5-4.32-5.03-5 4.3-.47-.55 5-4.29-4.32-5.04.57-.49z"
              fill="#fff"
            />
            <path
              d="m247.36 259.03-6.38 5.49-.47-.54 5.81-5-4.32-5.03-5 4.3-.47-.55 5-4.29-4.32-5.04.57-.49z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m219.63 262.05a20.28 20.28 0 0 1 3-2.55c3.57-2.44 5.91-.63 8.54 3.21s3.68 6.7 0 9.23a21.67 21.67 0 0 1 -3.43 1.87l-.37-.65a21.1 21.1 0 0 0 3.39-1.81c3.26-2.23 2.13-4.74-.24-8.19s-4.29-5.25-7.47-3.07a21.27 21.27 0 0 0 -2.92 2.51z"
              fill="#fff"
            />
            <path
              d="m219.63 262.05a20.28 20.28 0 0 1 3-2.55c3.57-2.44 5.91-.63 8.54 3.21s3.68 6.7 0 9.23a21.67 21.67 0 0 1 -3.43 1.87l-.37-.65a21.1 21.1 0 0 0 3.39-1.81c3.26-2.23 2.13-4.74-.24-8.19s-4.29-5.25-7.47-3.07a21.27 21.27 0 0 0 -2.92 2.51z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m220.16 268.56-3-5.29.66-.38 7.25 12.79-4.58 2.6c-2.54 1.44-4.42 1.06-5.88-1.5-1.11-2-1.16-3.8.53-5.25l-5.94-3.75.75-.42 5.85 3.68zm0 9.1 3.93-2.23-3.54-6.25-3.93 2.23c-2.32 1.32-2.36 3.08-1.28 5 1.2 2.12 2.69 2.48 4.82 1.27"
              fill="#fff"
            />
            <path
              d="m220.16 268.56-3-5.29.66-.38 7.25 12.79-4.58 2.6c-2.54 1.44-4.42 1.06-5.88-1.5-1.11-2-1.16-3.8.53-5.25l-5.94-3.75.75-.42 5.85 3.68zm0 9.1 3.93-2.23-3.54-6.25-3.93 2.23c-2.32 1.32-2.36 3.08-1.28 5 1.16 2.1 2.66 2.46 4.78 1.25z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m209.57 268.16h.76v14.7h-.76z"
              fill="#fff"
              transform="matrix(.89787395 -.44025261 .44025261 .89787395 -99.86 120.59)"
            />
            <path
              d="m209.57 268.16h.76v14.7h-.76z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              transform="matrix(.89787395 -.44025261 .44025261 .89787395 -99.86 120.59)"
            />
            <path
              d="m209.14 284.19-1.49.59-9.81-10.68.21 14.5-1.48.59-5.44-13.66.7-.28 5.18 13 .27-.11-.21-14.5 1.02-.4 9.81 10.68.27-.11-5.17-13 .7-.28z"
              fill="#fff"
            />
            <path
              d="m209.14 284.19-1.49.59-9.81-10.68.21 14.5-1.48.59-5.44-13.66.7-.28 5.18 13 .27-.11-.21-14.5 1.02-.4 9.81 10.68.27-.11-5.17-13 .7-.28z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m189.61 276.1h.76v14.7h-.76z"
              fill="#fff"
              transform="matrix(.95 -.3 .3 .95 -75.64 69.26)"
            />
            <path
              d="m189.61 276.1h.76v14.7h-.76z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              transform="matrix(.95 -.3 .3 .95 -75.64 69.26)"
            />
            <path
              d="m187.87 291.83-1.73.42-10.08-11.96-.56.14 3.29 13.59-.74.18-3.45-14.29 1.74-.42 10.1 11.95.53-.13-3.28-13.59.73-.18z"
              fill="#fff"
            />
            <path
              d="m187.87 291.83-1.73.42-10.08-11.96-.56.14 3.29 13.59-.74.18-3.45-14.29 1.74-.42 10.1 11.95.53-.13-3.28-13.59.73-.18z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m170.75 295.43-2.21.32-6.54-13.89.75-.11 2 4.27 6.94-1 .7-4.66.75-.11zm.77-9.69-6.49.95 3.97 8.31 1.16-.17z"
              fill="#fff"
            />
            <path
              d="m170.75 295.43-2.21.32-6.54-13.89.75-.11 2 4.27 6.94-1 .7-4.66.75-.11zm.77-9.69-6.49.95 3.97 8.31 1.16-.17z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path d="m160.25 281.94.98 14.67-.76.05-.93-13.96-7.15.48-.04-.71z" fill="#fff" />
            <path
              d="m160.25 281.94.98 14.67-.76.05-.93-13.96-7.15.48-.04-.71z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m144.3 284.11c.06-3.15 1.17-3.21 3.69-3.16v.71c-2.46-.05-2.88 0-2.93 2.78l-.24 12.68h-.76z"
              fill="#fff"
            />
            <path
              d="m144.3 284.11c.06-3.15 1.17-3.21 3.69-3.16v.71c-2.46-.05-2.88 0-2.93 2.78l-.24 12.68h-.76z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m136.52 282.5c-2.64-.23-4.26.56-4.49 3.22l-.9 10.54-.75-.06.9-10.55c.26-3.14 2.16-4.13 5.3-3.87 2.93.25 4.63 1.54 4.36 4.7l-.94 10.52-.75-.06.9-10.55c.22-2.63-1.22-3.71-3.67-3.91"
              fill="#fff"
            />
            <path
              d="m136.52 282.5c-2.64-.23-4.26.56-4.49 3.22l-.9 10.54-.75-.06.9-10.55c.26-3.14 2.16-4.13 5.3-3.87 2.93.25 4.63 1.54 4.36 4.7l-.94 10.52-.75-.06.9-10.55c.26-2.61-1.15-3.69-3.63-3.89z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m118.67 293.45s2.77.84 4 1.05c2.36.41 3.83-.19 4.19-2.26.43-2.52-.8-3.06-3.33-3.92s-4-1.78-3.59-4.39c.55-3.23 2.28-4.08 5.13-3.59 1.56.27 4.38 1.1 4.38 1.1l-.21.71s-2.8-.85-4.27-1.1c-2.36-.41-3.79.37-4.24 2.95-.36 2.11.63 2.77 3.11 3.61 2.76.92 4.33 1.68 3.81 4.72-.46 2.67-2.35 3.35-5.1 2.87a40.41 40.41 0 0 1 -4.06-1z"
              fill="#fff"
            />
            <path
              d="m118.67 293.45s2.77.84 4 1.05c2.36.41 3.83-.19 4.19-2.26.43-2.52-.8-3.06-3.33-3.92s-4-1.78-3.59-4.39c.55-3.23 2.28-4.08 5.13-3.59 1.56.27 4.38 1.1 4.38 1.1l-.21.71s-2.8-.85-4.27-1.1c-2.36-.41-3.79.37-4.24 2.95-.36 2.11.63 2.77 3.11 3.61 2.76.92 4.33 1.68 3.81 4.72-.46 2.67-2.35 3.35-5.1 2.87a40.41 40.41 0 0 1 -4.06-1z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m116.43 293.88-10.17-2.58.17-.7 4.71 1.2 3.44-13.56.73.19-3.44 13.56 4.74 1.2z"
              fill="#fff"
            />
            <path
              d="m116.43 293.88-10.17-2.58.17-.7 4.71 1.2 3.44-13.56.73.19-3.44 13.56 4.74 1.2z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m98.44 282.99h14.7v.76h-14.7z"
              fill="#fff"
              transform="matrix(.29987341 -.953979 .953979 .29987341 -196.27 299.29)"
            />
            <path
              d="m98.44 282.99h14.7v.76h-14.7z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              transform="matrix(.29987341 -.953979 .953979 .29987341 -196.27 299.29)"
            />
            <path
              d="m96.38 272.46a20.45 20.45 0 0 1 3.78 1c4 1.53 3.9 4.48 2.26 8.84s-3.39 6.85-7.57 5.27a21 21 0 0 1 -3.5-1.74l.32-.66a22.7 22.7 0 0 0 3.43 1.74c3.69 1.39 5.1-1 6.57-4.89s1.85-6.53-1.76-7.89a20.87 20.87 0 0 0 -3.73-1z"
              fill="#fff"
            />
            <path
              d="m96.38 272.46a20.45 20.45 0 0 1 3.78 1c4 1.53 3.9 4.48 2.26 8.84s-3.39 6.85-7.57 5.27a21 21 0 0 1 -3.5-1.74l.32-.66a22.7 22.7 0 0 0 3.43 1.74c3.69 1.39 5.1-1 6.57-4.89s1.85-6.53-1.76-7.89a20.87 20.87 0 0 0 -3.73-1z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m88.34 284.72-7.77-3.67.31-.64 7.09 3.34 2.6-5.53-5.94-2.8.3-.65 5.95 2.8 2.75-5.83-7.09-3.34.3-.65 7.77 3.67z"
              fill="#fff"
            />
            <path
              d="m88.34 284.72-7.77-3.67.31-.64 7.09 3.34 2.6-5.53-5.94-2.8.3-.65 5.95 2.8 2.75-5.83-7.09-3.34.3-.65 7.77 3.67z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m70.79 275.49-1.89-1.17 3.91-14.87.65.4-1.23 4.55 6 3.7 3.5-3.1.65.4zm6.83-6.9-5.57-3.46-2.33 8.87 1 .62z"
              fill="#fff"
            />
            <path
              d="m70.79 275.49-1.89-1.17 3.91-14.87.65.4-1.23 4.55 6 3.7 3.5-3.1.65.4zm6.83-6.9-5.57-3.46-2.33 8.87 1 .62z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m62.67 270.26-1.42-1.07 2.86-15.38-.46-.34-8.43 11.16-.61-.46 8.87-11.73 1.42 1.08-2.84 15.39.44.33 8.44-11.16.6.46z"
              fill="#fff"
            />
            <path
              d="m62.67 270.26-1.42-1.07 2.86-15.38-.46-.34-8.43 11.16-.61-.46 8.87-11.73 1.42 1.08-2.84 15.39.44.33 8.44-11.16.6.46z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m61.29 250.6-9.95 10.83-4-3.69c-2.72-2.5-1.26-5.89 1.24-8.61s6-4.72 8.71-2.22zm-13.49 6.61 3.47 3.19 9-9.78-3.47-3.18c-2.32-2.13-5.5-.1-7.63 2.22s-3.67 5.42-1.35 7.55"
              fill="#fff"
            />
            <path
              d="m61.29 250.6-9.95 10.83-4-3.69c-2.72-2.5-1.26-5.89 1.24-8.61s6-4.72 8.71-2.22zm-13.49 6.61 3.47 3.19 9-9.78-3.47-3.18c-2.32-2.13-5.5-.1-7.63 2.22s-3.69 5.42-1.37 7.55z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m33.46 241.82s1.61 2.41 2.4 3.33c1.56 1.82 3.08 2.29 4.67.92 1.94-1.67 1.33-2.86-.08-5.14s-2-4 0-5.67c2.48-2.14 4.35-1.7 6.24.5 1 1.19 2.68 3.62 2.68 3.62l-.62.42s-1.61-2.43-2.59-3.56c-1.56-1.82-3.16-2.13-5.14-.42-1.63 1.4-1.28 2.54.1 4.76 1.54 2.46 2.27 4-.07 6.07-2 1.76-3.94 1.08-5.76-1-1-1.23-2.47-3.39-2.47-3.39z"
              fill="#fff"
            />
            <path
              d="m33.46 241.82s1.61 2.41 2.4 3.33c1.56 1.82 3.08 2.29 4.67.92 1.94-1.67 1.33-2.86-.08-5.14s-2-4 0-5.67c2.48-2.14 4.35-1.7 6.24.5 1 1.19 2.68 3.62 2.68 3.62l-.62.42s-1.61-2.43-2.59-3.56c-1.56-1.82-3.16-2.13-5.14-.42-1.63 1.4-1.28 2.54.1 4.76 1.54 2.46 2.27 4-.07 6.07-2 1.76-3.94 1.08-5.76-1-1-1.23-2.47-3.39-2.47-3.39z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m30.47 239.38-5.07-6.94.58-.42 4.62 6.32 4.93-3.6-3.88-5.31.58-.42 3.88 5.31 5.2-3.81-4.62-6.32.58-.42 5.06 6.93z"
              fill="#fff"
            />
            <path
              d="m30.47 239.38-5.07-6.94.58-.42 4.62 6.32 4.93-3.6-3.88-5.31.58-.42 3.88 5.31 5.2-3.81-4.62-6.32.58-.42 5.06 6.93z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m31.49 214.93a20.4 20.4 0 0 1 2.4 3.08c2.27 3.68.35 5.93-3.62 8.38s-6.86 3.35-9.21-.46a20 20 0 0 1 -1.7-3.51l.65-.34a22.27 22.27 0 0 0 1.65 3.48c2.08 3.36 4.64 2.34 8.19.15s5.46-4 3.43-7.32a20.19 20.19 0 0 0 -2.37-3z"
              fill="#fff"
            />
            <path
              d="m31.49 214.93a20.4 20.4 0 0 1 2.4 3.08c2.27 3.68.35 5.93-3.62 8.38s-6.86 3.35-9.21-.46a20 20 0 0 1 -1.7-3.51l.65-.34a22.27 22.27 0 0 0 1.65 3.48c2.08 3.36 4.64 2.34 8.19.15s5.46-4 3.43-7.32a20.19 20.19 0 0 0 -2.37-3z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m28.17 209.18c-1.19-2.37-2.71-3.34-5.09-2.14l-9.45 4.76-.34-.67 9.45-4.76c2.81-1.42 4.65-.33 6.07 2.49 1.32 2.62 1.12 4.74-1.71 6.17l-9.45 4.76-.34-.67 9.45-4.76c2.36-1.19 2.52-3 1.41-5.18"
              fill="#fff"
            />
            <path
              d="m28.17 209.18c-1.19-2.37-2.71-3.34-5.09-2.14l-9.45 4.76-.34-.67 9.45-4.76c2.81-1.42 4.65-.33 6.07 2.49 1.32 2.62 1.12 4.74-1.71 6.17l-9.45 4.76-.34-.67 9.45-4.76c2.36-1.19 2.52-2.99 1.41-5.18z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m19.33 203.47 5.67-2.23.28.7-13.68 5.39-1.93-4.91c-1.07-2.72-.43-4.53 2.31-5.6 2.11-.83 3.93-.62 5.12 1.26l4.55-5.36.32.8-4.47 5.28zm-9-1.31 1.65 4.2 6.69-2.63-1.67-4.2c-1-2.48-2.72-2.77-4.75-2-2.27.89-2.84 2.31-1.94 4.6"
              fill="#fff"
            />
            <path
              d="m19.33 203.47 5.67-2.23.28.7-13.68 5.39-1.93-4.91c-1.07-2.72-.43-4.53 2.31-5.6 2.11-.83 3.93-.62 5.12 1.26l4.55-5.36.32.8-4.47 5.28zm-9-1.31 1.65 4.2 6.69-2.63-1.67-4.2c-1-2.48-2.72-2.77-4.75-2-2.25.92-2.82 2.34-1.92 4.63z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m6.55 192.02h14.7v.76h-14.7z"
              fill="#fff"
              transform="matrix(.95143334 -.30785483 .30785483 .95143334 -58.56 13.63)"
            />
            <path
              d="m6.55 192.02h14.7v.76h-14.7z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              transform="matrix(.95143334 -.30785483 .30785483 .95143334 -58.56 13.63)"
            />
            <path
              d="m5.98 192-2.69-10.15.69-.18 1.24 4.69 13.51-3.59.2.73-13.52 3.59 1.26 4.72z"
              fill="#fff"
            />
            <path
              d="m5.98 192-2.69-10.15.69-.18 1.24 4.69 13.51-3.59.2.73-13.52 3.59 1.26 4.72z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m16.54 172.81.13.74-6.21 1.15-7.38 6.22-.16-.86 6.64-5.58-8.19-2.85-.16-.87 9.11 3.19z"
              fill="#fff"
            />
            <path
              d="m16.54 172.81.13.74-6.21 1.15-7.38 6.22-.16-.86 6.64-5.58-8.19-2.85-.16-.87 9.11 3.19z"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
            />
            <path
              d="m11.08 161.16h-8.08a3 3 0 0 1 -3-3v-8.08a3 3 0 0 1 3-3h8.08a3 3 0 0 1 3 3v8.08a3 3 0 0 1 -3 3"
              fill="#fff"
              fill-rule="evenodd"
            />
            <path
              d="m282 158.16v-8.08a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8.08a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3-3"
              fill="#fff"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </svg>
    </>
  );
}
